import axios from 'axios';

export interface Config {
  NEXT_URL: string;
  API_BASE_URL: string;
  API_URL: string;
  CONSOLE_OUPUT?: string[];
  anotherConfig?: string;
  EMAIL_OVERDUE: number;
  EMAIL_OVERDUE_WARN: number;
}

const configFile = '/config.json';

// Default config values
const defaultConfig: Config = {
  NEXT_URL: import.meta.env.VITE_APP_NEXT_BASE_URL || 'http://localhost:5173',
  API_BASE_URL: import.meta.env.VITE_BASE_URL || 'https://api.preprod.seybold-fm.com',
  API_URL: import.meta.env.VITE_API_URL || 'http://localhost:3000',
  anotherConfig: 'just another config string',
  EMAIL_OVERDUE: 1,
  EMAIL_OVERDUE_WARN: 3,
};

const isValidJSON = (data: any): data is Config => {
  return typeof data === 'object' && data !== null;
};

const config: Config = { ...defaultConfig };

export const loadConfig = async () => {
  try {
    const response = await axios.get<Config>(configFile);

    if (isValidJSON(response.data)) {
      Object.assign(config, response.data);
    }
    await axios.get(`${config.API_URL}/v1/csrf/token`, { withCredentials: true });
  } catch (error) {
    console.info(
      '[sey-config] Failed to load configuration.json, using default values instead',
      config,
      error,
    );
  }
};

type loggingFilter =
  | 'sey-i18n'
  | 'sey-router'
  | 'sey-config'
  | 'sey-datatable'
  | 'sey-auth'
  | 'sey-iban';

export const hasLogging = (configKey?: loggingFilter): boolean =>
  !!configKey ? !!config.CONSOLE_OUPUT?.includes(configKey) : !!config.CONSOLE_OUPUT?.length;
export const hasLoggingPromise = async (configKey?: string): Promise<boolean> => {
  await loadConfig();

  return !!configKey ? !!config.CONSOLE_OUPUT?.includes(configKey) : !!config.CONSOLE_OUPUT?.length;
};

export default config;
